module.exports = __webpack_public_path__ + "static/media/icon2.84a906b0.svg";